import { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import './HipaaBreachBanner.css';

/**
 * HIPAA Third-Party Data Breach Notice (CareCloud)
 *
 * Deployed 2026-09-14 per Trinity Medical Management legal directive
 * (attorney Alex M. Smith). OCR guidance requires covered entities to make
 * substitute notice prominently available when a business associate (here,
 * CareCloud, the EMR vendor) experiences a HIPAA breach affecting PHI.
 *
 * Notice remains in place until legal counsel signals removal. Do not remove
 * without written direction from Trinity Medical Management legal.
 *
 * Dismiss state is sessionStorage (NOT localStorage) — OCR wants notice
 * AVAILABLE, not FORCED. Comes back on next visit.
 */
const STORAGE_KEY = 'hipaaBreachNoticeDismissed';

export default function HipaaBreachBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (_) {
      return false;
    }
  });

  if (dismissed) return null;

  const handleClose = () => {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (_) {}
    setDismissed(true);
  };

  return (
    <div
      className="hipaa-breach-banner"
      role="alert"
      aria-label="Third-party data breach notice"
    >
      <div className="hipaa-breach-banner__inner">
        <div className="hipaa-breach-banner__copy">
          <strong>Third-Party Data Breach Notice</strong>
          <span>
            Our EMR vendor CareCloud experienced a HIPAA data breach affecting
            protected health information. This notice is provided to affected
            patients. View notice &rarr;{' '}
            <a
              href="https://carecloudhealth.com/notice/index.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              carecloudhealth.com/notice/index.html
            </a>
            <br />
            Questions? Anonymous HIPAA hotline:{' '}
            <a href="tel:8443330850">844-333-0850</a>
          </span>
        </div>
        <button
          type="button"
          className="hipaa-breach-banner__close"
          aria-label="Dismiss third-party data breach notice"
          onClick={handleClose}
        >
          <FaTimes size={12} />
        </button>
      </div>
    </div>
  );
}
